import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="mb-4">
          <div className="w-16 h-16 border-4 border-t-cyan-400 border-r-purple-400 border-b-cyan-400 border-l-purple-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
        <h2 className="text-2xl font-bold mb-2 bg-gradient-to-r from-cyan-400 to-purple-500 text-transparent bg-clip-text">
          ARXHR<span className="text-purple-400">007</span>
        </h2>
        <p className="text-gray-300">Loading content...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;